import { getFilesIds } from '@components/pages/Products/components/RouteProduct/useGetFilesFromRoute';
import { getLocalizationById } from '@context/useMyRouting/helpers';
import getTaxNames, { TaxNameProps } from '@helpers/getTaxNames';
import { RouteWidgetBaseParameters } from '@pages/AdditionalServices/tabs/DeliveryForm/types';
import { getCurrencyFromProduct } from '@pages/Basket/components/ServicesList/helpers';
import useBasket from '@pages/Basket/useBasket';
import OfferDetail from '@pages/OfferDetail';
import { filesService } from '@services/requests/filesService';
import { FileData } from '@services/requests/filesService/interface';
import { OrderProduct } from '@services/requests/orderService/orderProductsLoader/interface';
import { currencyLoader } from '@services/requests/searchLoaders/currencyLoader';
import { CurrencyData } from '@services/requests/searchLoaders/currencyLoader/CurrencyLoaderQuery';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Пропсы компонента
export type OfferInPreOfferRouteListContainerProps = {
  product: OrderProduct;
  baseData: RouteWidgetBaseParameters;
  extractCurrencyFromProduct: boolean;
};

/**
 * Компонент обертка вывода информации о КП в листинге предварительно расчета
 * @param props
 */
const OfferInPreOfferRouteListContainer = (props: OfferInPreOfferRouteListContainerProps) => {
  const { useOrder } = useBasket();
  const [order] = useOrder().useState();
  const [files, setFiles] = useState<FileData[]>([]);
  const [taxNames, setTaxNames] = useState<TaxNameProps[]>([]);
  const [currencies, setCurrencies] = useState<CurrencyData[]>([]);

  const { baseData, product, extractCurrencyFromProduct } = props;
  const langCode = getLocalizationById(order.language_id).countryCode;
  const { t } = useTranslation('OfferContainers', { lng: langCode });
  const orderDataWithProduct = useMemo(
    () => ({
      ...order,
      id: order.id,
      date: new Date().toDateString(),
      products: [product],
      currency_id: extractCurrencyFromProduct
        ? getCurrencyFromProduct([product], currencies)?.id ?? order.currency_id
        : order.currency_id,
    }),
    [order, product, currencies]
  );

  useEffect(() => {
    const filesToLoad = getFilesIds(orderDataWithProduct.products, baseData);
    filesService().LoadFilesById(filesToLoad).then(setFiles);
    getTaxNames(order.language_id).then(setTaxNames);
    currencyLoader().Load().then(setCurrencies);
  }, []);

  if (!baseData || order.isLoading || taxNames.length === 0) {
    return <div />;
  }

  return (
    <OfferDetail
      customsPaymentsMode="full"
      isUseActualCourses={true}
      isExportMode={false}
      order={orderDataWithProduct}
      baseData={{ ...baseData, currencies }}
      taxNames={taxNames}
      files={files}
      selectedProducts={[product.id]}
      title={t('OfferContainers:OfferDetailTitle')}
    />
  );
};

export default OfferInPreOfferRouteListContainer;
